import React from 'react';
import { Typography } from '../../../atoms/typography/Typography';
import { Row } from '../../../atoms/row/Row';

import InfoPopup from '../../shared/infoPopup/InfoPopup';

const CompareTitle = ({ data, infoText }) => (
  <Row className="flex-1 w-full gap-3 my-2 lg:my-10 px-8 justify-center lg:mx-auto md:max-w-7xl">
    <Typography
      as="h1"
      fontVariant="h4"
      className="w-full max-md:leading-tight max-w-full"
    >
      {data.map((el, i) => (
        <span key={`CompareTitle-key-${el}`}>
          {el}
          {i !== data.length - 1 && (
            <>
              <br className="md:hidden" />
              <span className="font-light px-2">vs</span>
              <br className="md:hidden" />
            </>
          )}
        </span>
      ))}
    </Typography>
    {infoText && <InfoPopup description={infoText} displayDirection="left" />}
  </Row>
);

export default CompareTitle;
